module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-2019-desktop-2440x300.11de49e2.jpg";